<template>
  <dp-container v-if="loading">
    <dp-loading />
  </dp-container>
  <dp-container v-else class="d-flex flex-column">
    <!-- Admin Back Link -->
    <b-row v-if="isAdmin" class="mt-3 mb-4">
      <b-col cols="6">
        <b-link :to="{ name: 'AdminRedirect' }"> {{ '&#8592; Back' }}</b-link>
      </b-col>
    </b-row>
    <!-- Product Type Navbar -->
    <ProductTypeNavbar v-if="showProductTypeNavbar" />
    <!-- Marketing Collections -->
    <section v-for="(marketingCollection, idx) in marketingCollections" :key="`marketing-collection-${idx}`">
      <b-row class="d-flex flex-column align-items-start" no-gutters>
        <b-col v-if="getContentCollectionItems(marketingCollection)" class="d-flex flex-column">
          <MarketingContent
            v-for="(content, index) in getContentCollectionItems(marketingCollection)"
            :key="`marketing-content-${index}`"
            :content="getMarketingContent(content)"
            :content-type="getMarketingContentType(content)"
            :style="{ order: content.position }"
            redirect-path="store"
            v-on="$listeners"
          />
        </b-col>
      </b-row>
    </section>
  </dp-container>
</template>

<script>
import getImage from '@/mixins/getImage';
import { mapGetters, mapState } from 'vuex';
import { DpContainer, DpLoading } from '@docupet/component-library';
import ProductTypeNavbar from '@/components/ProductTypeNavbar';
import MarketingContent from '@/components/MarketingContent';

export default {
  name: 'Homepage',
  components: {
    DpLoading,
    DpContainer,
    MarketingContent,
    ProductTypeNavbar,
  },
  mixins: [getImage],
  metaTag() {
    return this.$router.currentRoute.meta;
  },
  watch: {
    showHomePage() {
      if (!this.showHomePage) {
        this.$router.push({ name: 'TagStore' });
      }
    },
  },
  computed: {
    ...mapState({
      city: (state) => state.user.city,
      loading: (state) => state.tagProduct.loading || state.order.itemLoading,
      isAdmin: (state) => state.user.user.id && state.user.user.__typename == 'Administrator',
    }),
    ...mapGetters({
      getRequiredPetByPetId: 'order/getRequiredPetByPetId',
      showHomePage: 'user/showHomePage',
    }),
    requiredPet() {
      return this.getRequiredPetByPetId(this.petId, !(this.isAdmin && this.$router?.currentRoute?.query?.single));
    },
    isLicensingFlow() {
      return this.requiredPet?.licensing && !this.requiredPet?.hasTag;
    },
    showProductTypeNavbar() {
      return !this.isAdmin && !this.isLicensingFlow && (this.city?.showCollarsLeashesProducts || this.city?.showPetEssentialsProducts);
    },
    marketingCollections() {
      return [
        this.city?.homeLandingPageHeroMarketingCollection,
        this.city?.homeLandingPageTagsMarketingCollection,
        this.city?.homeLandingPageWalletCardsMarketingCollection,
        this.city?.homeLandingPageCollarsMarketingCollection,
        this.city?.homeLandingPagePetEssentialsMarketingCollection,
      ];
    },
  },
  methods: {
    getContentCollectionItems(marketingCollection) {
      return marketingCollection?.marketingContentCollectionItems;
    },
    getMarketingContent(content) {
      return content?.marketingContent;
    },
    getMarketingContentType(content) {
      return this.getMarketingContent(content)?.type;
    },
  },
};
</script>

<style lang="scss" scoped></style>
